// extracted by mini-css-extract-plugin
export var accountUser = "style-mod--account-user--ab7d0";
export var active = "style-mod--active--5d7a7";
export var badge = "style-mod--badge--5e23e";
export var body = "style-mod--body--59657";
export var cartContainer = "style-mod--cart-container--7d299";
export var cartCount = "style-mod--cart-count--f374a";
export var cartIcon = "style-mod--cart-icon--d704e";
export var center = "style-mod--center--d594b";
export var closeIcon = "style-mod--close-icon--50450";
export var contact = "style-mod--contact--f7e5d";
export var desktopHeader = "style-mod--desktop-header--8a5e9";
export var fadeIn = "style-mod--fade-in--9a103";
export var fadeInvisible = "style-mod--fade-invisible--e4d62";
export var friends = "style-mod--friends--6c9ad";
export var head = "style-mod--head--8579e";
export var header = "style-mod--header--69216";
export var hiddenBestseller = "style-mod--hidden-bestseller--0f2fe";
export var inviteFriends = "style-mod--invite-friends--ae516";
export var left = "style-mod--left--50e7c";
export var login = "style-mod--login--22470";
export var logo = "style-mod--logo--a0199";
export var menu = "style-mod--menu--f0780";
export var middle = "style-mod--middle--c1cfa";
export var mobileHeader = "style-mod--mobile-header--65622";
export var mobileLogo = "style-mod--mobile-logo--f950b";
export var newLogo = "style-mod--new-logo--6f7e0";
export var opened = "style-mod--opened--55e23";
export var right = "style-mod--right--749fb";
export var tabContent = "style-mod--tab-content--2951d";
export var top = "style-mod--top--373c5";
export var trustedShop = "style-mod--trusted-shop--12233";